import { render } from "./Statusbar.vue?vue&type=template&id=63cb6538"
import script from "./Statusbar.vue?vue&type=script&lang=js"
export * from "./Statusbar.vue?vue&type=script&lang=js"

import "./Statusbar.vue?vue&type=style&index=0&id=63cb6538&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__